export default "__VITE_PUBLIC_ASSET__2e06d5a6__"